import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sidebar-open",
  "use": "icon-sidebar-open-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-sidebar-open\"><path d=\"M22.666 2H21v20h1.666V2ZM10.821 15.822l2.989-2.989H2v-1.666h11.81L10.82 8.178 12 7l5 5-5 5-1.178-1.178Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol